"use strict";
// @todo: define error response data + zod schema
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnExpectedError = exports.ForbiddenError = exports.BadRequestError = exports.UnauthorizedError = void 0;
class UnauthorizedError extends Error {
    data;
    constructor(data) {
        super();
        this.data = data;
    }
}
exports.UnauthorizedError = UnauthorizedError;
class BadRequestError extends Error {
    data;
    constructor(data) {
        super();
        this.data = data;
    }
}
exports.BadRequestError = BadRequestError;
class ForbiddenError extends Error {
    data;
    constructor(data) {
        super();
        this.data = data;
    }
}
exports.ForbiddenError = ForbiddenError;
class UnExpectedError extends Error {
    data;
    constructor(data) {
        super();
        this.data = data;
    }
}
exports.UnExpectedError = UnExpectedError;
